import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = null;

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (_, { payload: { bills = null } }) => bills,
  },
  initialState,
);

export const getBillsFilter = state => state;
